import { useSignOut } from "@/hook/useAuth";
import { useGetConfig } from "@/hook/useConfig";
import { useGetMe } from "@/hook/useUser";
import ScrollToTop from "@/shared/utils/ScrollToTop";
import { showToast } from "@/shared/utils/toast";
import { useAuthStore } from "@/store/useAuth";
import { useConfigStore } from "@/store/useConfig";
import { useUserStore } from "@/store/useUser";
import { useEffect } from "react";

export default function AuthProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { accessToken } = useAuthStore();
  const { user } = useUserStore();
  const { config } = useConfigStore();

  const { mutate: signOut } = useSignOut();

  const {
    mutate: getMe,
    isPending: isGetMePending,
    isError: isGetMeError,
  } = useGetMe();

  const {
    mutate: getConfig,
    isPending: isGetConfigPending,
    isError: isGetConfigError,
  } = useGetConfig();

  const isPending = isGetMePending || isGetConfigPending;
  const isError = isGetMeError || isGetConfigError;

  useEffect(() => {
    if (!accessToken) return;
    if (isPending) return;
    if (isError) {
      showToast.error({
        title: "Something went wrong!",
        description: "Please sign in again.",
        duration: 5000,
      });
      return signOut();
    }
    if (!user) getMe();
    if (!config) getConfig();
  }, [accessToken, isPending, isError]);

  return (
    <>
      <ScrollToTop />
      {children}
    </>
  );
}
